module.exports = __webpack_public_path__ + "static/media/chevron-left-white.9a02b6cf.svg";